<template>
  <div class="choose-person margin10 pct100 flex-layout">
    <el-input class="input-area"
              v-if="!showPersonList"
              :disabled="disabled"
              :placeholder="'请选择' + title"
              readonly
              v-model="personStr">
      <el-button slot="suffix"
                 :disabled="disabled"
                 type="text"
                 @click="openChoose">选择</el-button>
    </el-input>
    <div class="person-show list-area"
         v-if="showPersonList">
      <div class="title-text">
        <span>{{ '请选择'+title }}</span>
      </div>
      <div v-if="searchAble">
        <el-input v-model="searchText"
                  clearable
                  placeholder="输入搜索关键字"
                  @keyup.enter.native="searchPerson()"
                  @clear="searchPerson">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="searchPerson"></el-button>
        </el-input>
      </div>
      <div class="person-list flex">
        <el-scrollbar class="scroll-bar"
                      ref="personScroller">
          <div v-if="personList && personList.length">
            <div ref="personListContent"
                 v-if="multiCheck">
              <el-checkbox-group class="person-choose-list"
                                 v-model="checkedList">
                <div class="person-item"
                     v-for="(item, index) in personList"
                     :key="index">
                  <el-checkbox class="person-checkbox"
                               :label="item.id">
                    {{ item.nickName }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <div ref="personListContent"
                 v-else>
              <el-radio-group class="person-choose-list"
                              v-model="checkedValue">
                <div class="person-item"
                     v-for="(item, index) in personList"
                     :key="index">
                  <el-radio class="person-radio"
                            :label="item.id">
                    {{ item.nickName }}
                    <!-- <div class="flex-valign">
                      <div class="flex-row">
                        <span class="flex-auto">{{
                          item.nickName
                        }}</span>
                        <span class="flex-auto">{{
                          item.workNo ? item.workNo : "访客"
                        }}</span>
                      </div>
                      <div class="flex-row">
                        <span class="flex-auto"
                          >{{ item.phone }}</span
                        >
                        <span class="flex-auto"
                          >{{ item.plateCode }}</span
                        >
                      </div>
                    </div> -->
                  </el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="no-data-text"
               v-else>无数据</div>
        </el-scrollbar>
      </div>
      <div class="footer dialog-footer tc">
        <el-button size="mini"
                   type="primary"
                   @click="submitPerson()">{{
          $t("workOrder.button.confirm")
        }}</el-button>
        <el-button size="mini"
                   @click="closePerson">{{
          $t("workOrder.button.cancel")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: "choose-person",
  model: {
    prop: "selectPerson",
    event: "handleReturn",
  },
  props: {
    title: {
      type: String,
      default: "执行人员",
    },
    selectPerson: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searchAble: {
      type: Boolean,
      default: false,
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiCheck: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    selectPerson (newVal) {
      this.checkedList = (newVal || []).map((item) => {
        return item.id;
      });
      this.checkedValue = this.checkedList[0];
      this.personStr = (newVal || [])
        .map((item) => {
          return item.nickName;
        })
        .join("、");
    },
  },
  data () {
    return {
      personList: [],
      personStr: "",
      showPersonList: false,
      checkedList: [],
      checkedValue: "",
      searchText: "",
      pageInfo: { pageNo: 1, pageNum: 1, pageSize: 100 },
      total: 0,
    };
  },
  methods: {
    openChoose () {
      if (this.showPersonList) {
        this.showPersonList = !this.showPersonList
        return
      }
      this.showPersonList = true;
      if (!this.personList || !this.personList.length) {
        this.queryPerson();
      }
      this.$nextTick(() => {
        let scrollbarEl = this.$refs.personScroller.wrap;
        let scrollHeight = scrollbarEl.scrollHeight;
        if (scrollbarEl) {
          scrollbarEl.onscroll = () => {
            let contentHeight = this.$refs.personListContent.scrollHeight;
            if (scrollbarEl.scrollTop >= contentHeight - scrollHeight - 0) {
              this.$log.debug("滚动到底");
              if (!this.searching && this.hasNext) {
                this.pageInfo.pageNo++;
                this.pageInfo.pageNum++;
                this.queryPerson();
              }
            }
          };
        }
      });
    },
    searchPerson () {
      this.personList = [];
      this.pageInfo.pageNo = 1;
      this.pageInfo.pageNum = 1;
      this.queryPerson();
    },
    queryPerson () {
      this.searching = true;
      this.hasNext = true;
      let param = {
        ...this.pageInfo,
        containOwnFlag: "1",
      };
      if (this.searchAble) {
        // param.queryStr = this.searchText;
        param.nickName = this.searchText;
      }
      let url = api.workOrder.queryResultsByPag
      // this.searchAble
      //   ? api.workOrder.queryPersonnelVehicleList
      //   : api.workOrder.queryResultsByPag;
      /**
       * 查询执行人员列表接口
       */
      this.$fetch(url, param).then((res) => {
        this.searching = false;
        if (res.success) {
          let personList = res.returnObj.list;
          this.hasNext = personList.length >= this.pageInfo.pageSize;
          // if (this.searchAble) {
          //   personList.map((item) => {
          //     item.nickName = item.name;
          //     item.id = item.personnelCode;
          //   });
          // }
          this.personList = this.personList.concat(personList);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    submitPerson () {
      if (!this.multiCheck) {
        this.checkedList = [this.checkedValue];
      }
      let result = [];
      this.personList.forEach((item) => {
        if (this.checkedList.indexOf(item.id) !== -1) {
          result.push(item);
        }
      });
      this.$emit("handleReturn", result);
      this.closePerson();
    },
    closePerson () {
      this.showPersonList = false;
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-person {
  z-index: 99;
  position: relative;
  .input-area {
    flex: 1;
  }

  .list-area {
    margin-left: 10px;
    flex: 2;
  }

  .person-show {
    background-color: #262a49;
    // @include set_theme_color(background-color, dialog-main-bg-color);
    .title-text {
      background-color: #272b37;
      padding: 10px;
    }
    .body {
      background-color: #171c28;
    }
    .footer {
      padding: 5px;
      background-color: #272b37;
    }
    .person-list {
      overflow: hidden;
      height: 200px;
    }

    .person-item {
      @include set_theme_color(background-color, content-bg-color);

      &:nth-child(odd) {
        @include set_theme_color(background-color, menu-tab-bg-color);
      }

      &:hover {
        @include set_theme_color(background-color, item-active-bg-color);
      }
    }

    .person-choose-list {
      width: 100%;
    }

    .person-radio,
    .person-checkbox {
      width: 100%;
      padding: 8px 10px;
    }
  }

  .person-info-item {
    width: 50%;
  }

  .no-data-text {
    height: 100%;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>